"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountRepositoryImpl = void 0;
const FormData = require('form-data');
class AccountRepositoryImpl {
    fetcherAmplify;
    fetcherAxios;
    constructor(fetcherAmplify, fetcherAxios) {
        this.fetcherAmplify = fetcherAmplify;
        this.fetcherAxios = fetcherAxios;
    }
    async saveFile(url, fields, file) {
        const formData = new FormData();
        const keys = [
            'Content-Type',
            'key',
            'bucket',
            'X-Amz-Algorithm',
            'X-Amz-Credential',
            'X-Amz-Date',
            'X-Amz-Security-Token',
            'Policy',
            'X-Amz-Signature',
        ];
        keys.forEach((name) => {
            formData.append(name, fields[name]);
        });
        formData.append('file', file);
        return this.fetcherAxios.post(url, formData);
    }
    async listAccounts(customer) {
        return await this.fetcherAmplify.get(`/v1/customers/${customer.id}/accounts`, {
            queryStringParameters: {
                customerType: customer?.type,
            },
        });
    }
    async deleteAccount(customer, accountId) {
        await this.fetcherAmplify.delete(`/v1/customers/${customer.id}/accounts/${accountId}`, {
            queryStringParameters: {
                customerType: customer?.type,
            },
        });
    }
    async createAccount(customer, account, image) {
        const request = {
            country: 'PE',
            bank: {
                id: account.idBank,
            },
            currency: account.currency,
            type: account.type,
            number: account.number,
            location: account.location,
            ...(account.cci && { cci: account.cci }),
            ...(account.imageAccount && {
                proof: {
                    contentType: account.imageAccount,
                },
            }),
        };
        const response = await this.fetcherAmplify.post(`/v1/customers/${customer.id}/accounts`, {
            queryStringParameters: {
                customerType: customer?.type,
            },
            body: request,
        });
        if (response?.proof?.upload && image) {
            const { url, fields } = response?.proof?.upload;
            await this.saveFile(url, fields, image);
        }
        return response;
    }
    async updateAccount(customer, account, image) {
        const request = {
            type: account.type,
            number: account.number,
            cci: account.cci,
            ...(account.bankId && {
                bank: {
                    id: account.bankId,
                },
            }),
            ...(account.location && { location: account.location }),
            ...(account.currency && { currency: account.currency }),
            ...(account.imageAccount && {
                proof: {
                    contentType: account.imageAccount,
                },
            }),
        };
        const response = await this.fetcherAmplify.put(`/v1/customers/${customer.id}/accounts/${account.accountId}`, {
            queryStringParameters: {
                customerType: customer?.type,
            },
            body: request,
        });
        if (response?.proof?.upload && image) {
            const { url, fields } = response?.proof?.upload;
            await this.saveFile(url, fields, image);
        }
        return response;
    }
}
exports.AccountRepositoryImpl = AccountRepositoryImpl;
//# sourceMappingURL=AccountRepositoryImpl.js.map